var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import * as Yup from 'yup';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { Divider, TextField } from '@mui/material';
import { InvoiceOptions, dummySOWOptions, dummyTaxMethodOptions, } from '../../Transfer/Transfer.constant';
import { useMemo, useState } from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import DrawerComponent from '@src/components/Atoms/Drawer/Drawer';
import { FormatYearMonthDate } from '@src/app/helper';
import InputFormik from '@src/components/Atoms/Formik/Input/InputFormik';
import MultiSelectFormik from '@src/components/Atoms/Formik/MultiSelect/MultiSelectFormik';
import SelectFormik from '@src/components/Atoms/Formik/Select/SelectFormik';
import TextAreaFormik from '@src/components/Atoms/Formik/TextArea/TextAreaFormik';
import dayjs from 'dayjs';
import { handleFocus } from '@src/app/helper/NumberHelpers';
import { toast } from 'react-toastify';
import { useBankAccounts } from '@src/app/pages/TalentPage/TalentHooks/TalentDetail.hooks';
import { useCompanies } from '@src/app/pages/LookupPage/LookupHooks/Lookup.hooks';
import { useFormik } from 'formik';
import { useJob } from '@src/app/pages/JobPage/JobHooks/Job.hooks';
import { SOWStatus } from '../../Transfer/Transfer.enum';
var TemplateInvoiceSchema = Yup.object().shape({
    startDate: Yup.string().required('Field belum diisi'),
    endDate: Yup.string().required('Field belum diisi'),
    date: Yup.string().required('Field belum diisi'),
    talentBankAccountPubId: Yup.string().required('Field belum diisi'),
    totalTransfer: Yup.string().required('Field belum diisi'),
    pajakMethod: Yup.string().required('Field belum diisi'),
    SOWOption: Yup.string().required('Field harus diisi'),
    paymentestimate: Yup.string().required('Field harus diisi'),
    description: Yup.string().when('SOWOption', {
        is: function (option) { return option === SOWStatus.NotSOW; },
        then: Yup.string().required('Deskripsi wajib diisi jika Tidak Sesuai SOW terpilih'),
        otherwise: Yup.string().nullable(),
    }),
    managerName: Yup.string().when('option', {
        is: function (option) { return option === 'Manager'; },
        then: Yup.string().required('Field belum diisi'),
        otherwise: Yup.string().nullable(),
    }),
});
var TemplateInvoice = function (_a) {
    var isOpen = _a.isOpen, handleClose = _a.handleClose, id = _a.id, talentId = _a.talentId;
    var _b = useState(dayjs().format('YYYY-MM-DD').toString()), startDate = _b[0], setStartDate = _b[1];
    var _c = useState(dayjs().format('YYYY-MM-DD').toString()), endDate = _c[0], setEndDate = _c[1];
    var _d = useState(dayjs().format('YYYY-MM-DD').toString()), date = _d[0], setDate = _d[1];
    var onChangeDate = function (e, name) {
        var event = { target: { name: '', value: null } };
        event.target.value = e == null ? '' : FormatYearMonthDate(e);
        TemplateInvoiceFormik.setFieldValue(name, event.target.value);
        switch (name) {
            case 'startDate':
                return setStartDate(event.target.value);
            case 'endDate':
                return setEndDate(event.target.value);
            case 'date':
                return setDate(event.target.value);
        }
    };
    var templateInvoiceJob = useJob(undefined, false).templateInvoiceJob;
    var TemplateInvoiceValues = {
        companyPubId: '',
        startDate: startDate ? startDate : dayjs().format('YYYY-MM-DD').toString(),
        endDate: endDate ? endDate : dayjs().format('YYYY-MM-DD').toString(),
        date: date ? date : dayjs().format('YYYY-MM-DD').toString(),
        talentBankAccountPubId: '',
        totalTransfer: '',
        pajakMethod: '',
        description: '',
        option: 'Personal',
        managerName: '',
        paymentestimate: '',
        SOWOption: SOWStatus.SOW,
    };
    //company
    var companies = useCompanies().companies;
    var optionCompanies = companies &&
        companies.data &&
        companies.data.length > 0 &&
        companies.data.map(function (company) { return ({
            name: company.name,
            value: company.pubId,
        }); });
    // bankAccount
    var _e = useState({
        page: 1,
        pageSize: 100,
        keyword: '',
        filterBy: "[[\"talent.pubId\", \"".concat(talentId, "\"]]"),
        initialFilterBy: "[[\"recordStatus\", \"Active\"]]",
    }), filterBankAccount = _e[0], setFilterBankAccount = _e[1];
    var _f = useBankAccounts(talentId, !!talentId, filterBankAccount), bankAccounts = _f.bankAccounts, isLoadingBankAccount = _f.isLoading;
    var _g = useState(), selectedBankAccount = _g[0], setSelectedBankAccount = _g[1];
    var optionBankAccount = useMemo(function () {
        return __spreadArray([], ((bankAccounts === null || bankAccounts === void 0 ? void 0 : bankAccounts.map(function (bank) { return ({
            label: "".concat(bank.accountName, " - ").concat(bank.accountNumber, " - ").concat(bank.bank.name),
            value: bank.pubId,
        }); })) || []), true);
    }, [bankAccounts]);
    var onChangeBankAccount = function (e) {
        setSelectedBankAccount(e);
        TemplateInvoiceFormik.setFieldValue('talentBankAccountPubId', e.value);
    };
    var TemplateInvoiceFormik = useFormik({
        initialValues: TemplateInvoiceValues,
        enableReinitialize: false,
        validationSchema: TemplateInvoiceSchema,
        onSubmit: function (values, _a) {
            var resetForm = _a.resetForm;
            return __awaiter(void 0, void 0, void 0, function () {
                var formValues, companyPubId, startDate, endDate, date, talentBankAccountPubId, totalTransfer, pajakMethod, description, option, managerName, SOWOption, paymentestimate, finaltotalTransfer, formData, file, FILE_API_BASE_URL, url, e_1, error;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            formValues = __assign({ id: id }, values);
                            companyPubId = formValues.companyPubId, startDate = formValues.startDate, endDate = formValues.endDate, date = formValues.date, talentBankAccountPubId = formValues.talentBankAccountPubId, totalTransfer = formValues.totalTransfer, pajakMethod = formValues.pajakMethod, description = formValues.description, option = formValues.option, managerName = formValues.managerName, SOWOption = formValues.SOWOption, paymentestimate = formValues.paymentestimate;
                            finaltotalTransfer = totalTransfer.replace(/\./g, '');
                            formData = {
                                id: id,
                                companyPubId: companyPubId,
                                startDate: startDate,
                                endDate: endDate,
                                date: date,
                                talentBankAccountPubId: talentBankAccountPubId,
                                pajakMethod: pajakMethod,
                                description: description,
                                totalTransfer: finaltotalTransfer,
                                option: option,
                                managerName: managerName,
                                SOWOption: SOWOption,
                                paymentestimate: paymentestimate,
                            };
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 3, 4, 5]);
                            return [4 /*yield*/, templateInvoiceJob(formData)];
                        case 2:
                            file = _b.sent();
                            handleClose();
                            FILE_API_BASE_URL = process.env.NEXUS_FILE_API_URL;
                            url = "".concat(FILE_API_BASE_URL, "/").concat(file.pubId, "/download");
                            window.open(url, '_blank', 'noreferrer');
                            return [3 /*break*/, 5];
                        case 3:
                            e_1 = _b.sent();
                            error = e_1.response.message;
                            toast.error(error);
                            return [3 /*break*/, 5];
                        case 4:
                            resetForm();
                            setStartDate(dayjs().format('YYYY-MM-DD').toString());
                            setEndDate(dayjs().format('YYYY-MM-DD').toString());
                            setDate(dayjs().format('YYYY-MM-DD').toString());
                            setSelectedBankAccount(undefined);
                            return [7 /*endfinally*/];
                        case 5: return [2 /*return*/];
                    }
                });
            });
        },
    });
    var isInputOK = useMemo(function () {
        return (TemplateInvoiceFormik.values.companyPubId !== '' &&
            TemplateInvoiceFormik.values.startDate !== '' &&
            TemplateInvoiceFormik.values.endDate !== '' &&
            TemplateInvoiceFormik.values.date !== '' &&
            TemplateInvoiceFormik.values.option !== '' &&
            TemplateInvoiceFormik.values.pajakMethod !== '' &&
            TemplateInvoiceFormik.values.talentBankAccountPubId !== null &&
            selectedBankAccount !== undefined &&
            TemplateInvoiceFormik.values.totalTransfer !== '');
    }, [TemplateInvoiceFormik.values]);
    return (_jsx(DrawerComponent, __assign({ open: isOpen, size: 'LG', handleClose: handleClose, title: 'Template Invoice' }, { children: _jsxs("form", __assign({ className: 'form w-100', onSubmit: TemplateInvoiceFormik.handleSubmit, noValidate: true, id: 'template-invoice-form' }, { children: [optionCompanies && (_jsxs(_Fragment, { children: [_jsx(Divider, {}), _jsx("div", __assign({ className: 'my-5' }, { children: _jsx(SelectFormik, { label: 'Company', name: 'companyPubId', formik: TemplateInvoiceFormik, optionList: optionCompanies, isRequired: true }) }))] })), _jsx("div", __assign({ className: 'my-5' }, { children: _jsxs(LocalizationProvider, __assign({ dateAdapter: AdapterDayjs }, { children: [_jsx("label", __assign({ className: 'form-label fs-6 fw-bolder required text-dark' }, { children: "Start Date " })), _jsx(DatePicker, { value: startDate, inputFormat: 'DD/MM/YYYY', dayOfWeekFormatter: function (day) { return day; }, onChange: function (e) {
                                    onChangeDate(e, 'startDate');
                                }, renderInput: function (params) { return (_jsx(TextField, __assign({}, params, { className: 'product-datepicker form-control' }))); } })] })) })), _jsx("div", __assign({ className: 'my-5' }, { children: _jsxs(LocalizationProvider, __assign({ dateAdapter: AdapterDayjs }, { children: [_jsx("label", __assign({ className: 'form-label fs-6 fw-bolder required text-dark' }, { children: "End Date " })), _jsx(DatePicker, { value: endDate, inputFormat: 'DD/MM/YYYY', dayOfWeekFormatter: function (day) { return day; }, onChange: function (e) {
                                    onChangeDate(e, 'endDate');
                                }, renderInput: function (params) { return (_jsx(TextField, __assign({}, params, { className: 'product-datepicker form-control' }))); } })] })) })), _jsx("div", __assign({ className: 'my-5' }, { children: _jsxs(LocalizationProvider, __assign({ dateAdapter: AdapterDayjs }, { children: [_jsx("label", __assign({ className: 'form-label fs-6 fw-bolder required text-dark' }, { children: "Invoice Date " })), _jsx(DatePicker, { value: date, inputFormat: 'DD/MM/YYYY', dayOfWeekFormatter: function (day) { return day; }, onChange: function (e) {
                                    onChangeDate(e, 'date');
                                }, renderInput: function (params) { return (_jsx(TextField, __assign({}, params, { className: 'product-datepicker form-control' }))); } })] })) })), _jsx(Divider, {}), _jsx("div", __assign({ className: 'my-5' }, { children: _jsx(SelectFormik, { label: 'Pihak', name: 'option', formik: TemplateInvoiceFormik, optionList: InvoiceOptions, isRequired: true }) })), TemplateInvoiceFormik.values.option === 'Manager' && (_jsx("div", __assign({ className: 'my-5' }, { children: _jsx(InputFormik, { label: 'Nama Manajer', type: 'text', placeholder: 'Nama Manajer', name: 'managerName', formik: TemplateInvoiceFormik, isRequired: true }) }))), _jsx(Divider, {}), _jsx("div", __assign({ className: 'my-5' }, { children: optionBankAccount && (_jsx("div", __assign({ className: 'my-5' }, { children: _jsx(MultiSelectFormik, { name: 'talentBankAccountPubId ', label: 'No Rekening', formik: TemplateInvoiceFormik, isMulti: false, options: optionBankAccount, value: selectedBankAccount ? [selectedBankAccount] : [], onchange: onChangeBankAccount, isRequired: true }) }))) })), _jsx("div", __assign({ className: 'my-5' }, { children: _jsx(InputFormik, { label: 'Total Transfer', type: 'text', placeholder: 'Total Transfer', name: 'totalTransfer', formik: TemplateInvoiceFormik, formatNumber: true, onfocus: handleFocus, isRequired: true }) })), _jsx("div", __assign({ className: 'my-5' }, { children: _jsx(SelectFormik, { label: 'Metode Pajak', name: 'pajakMethod', formik: TemplateInvoiceFormik, optionList: dummyTaxMethodOptions, isRequired: true }) })), _jsx("div", __assign({ className: 'my-5' }, { children: _jsx(SelectFormik, { label: 'SOW', name: 'SOWOption', formik: TemplateInvoiceFormik, optionList: dummySOWOptions, isRequired: true }) })), _jsx("div", __assign({ className: 'my-5' }, { children: _jsx(TextAreaFormik, { label: 'Deskripsi Kerjasama', placeholder: 'Deskripsi Kerjasama', name: 'description', formik: TemplateInvoiceFormik, isRequired: TemplateInvoiceFormik.values.SOWOption !== SOWStatus.SOW }) })), _jsx("div", __assign({ className: 'my-5' }, { children: _jsx(SelectFormik, { label: 'Estimasi Pembayaran', name: 'paymentestimate', formik: TemplateInvoiceFormik, optionList: [
                            { name: '7 Hari Kerja', value: '7' },
                            { name: '14 Hari Kerja', value: '14' },
                        ], isRequired: true }) })), _jsx("div", __assign({ className: 'my-5' }, { children: _jsxs("div", __assign({ style: { textAlign: 'right' } }, { children: [_jsx("button", __assign({ type: 'button', className: 'btn btn-secondary btn-active-light-primary btn-sm', onClick: handleClose, disabled: TemplateInvoiceFormik.isSubmitting, style: { marginRight: '1rem' } }, { children: _jsx("span", __assign({ className: 'indicator-label' }, { children: "Batal" })) })), _jsxs("button", __assign({ type: 'submit', className: 'btn btn-primary btn-sm', disabled: TemplateInvoiceFormik.isSubmitting || !isInputOK }, { children: [!TemplateInvoiceFormik.isSubmitting && (_jsx("span", __assign({ className: 'indicator-label' }, { children: "Simpan" }))), TemplateInvoiceFormik.isSubmitting && (_jsxs("span", __assign({ className: 'indicator-progress', style: { display: 'block' } }, { children: ["Mohon tunggu...", _jsx("span", { className: 'spinner-border spinner-border-sm align-middle ms-2' })] })))] }))] })) }))] })) })));
};
export default TemplateInvoice;
